import React, { useState, useCallback } from "react";
import { CreateTaskButton } from "../components";
import CreateTaskModal from "./CreateTaskModal";

const CreateTask = React.memo(() => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = useCallback(() => setIsOpen(true), [setIsOpen]);
  const handleClose = useCallback(() => setIsOpen(false), [setIsOpen]);

  return (
    <React.Fragment>
      <CreateTaskButton
        onClick={handleClick}
      />
      <CreateTaskModal
        isOpen={isOpen}
        onClose={handleClose}
      />
    </React.Fragment>
  );
});

export default CreateTask;
